var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPen16(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    stroke: "#333",
    strokeWidth: 2,
    transform: "translate(1 1)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M0,14.0000003 L0,10.5 L9.52819551,0.971804444 C10.5521834,-0.0521834425 12.2100132,-0.0511109812 13.2309183,0.974055486 L13.0263714,0.768654766 C14.0473407,1.79388587 14.0385691,3.46143083 13.0220933,4.47790662 L3.5,14.0000003 L0,14.0000003 Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.3125,2.1875 L11.8125,5.6875"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPen16);
export default __webpack_public_path__ + "static/media/pen-16.2aee961f21440b343a67b9b1e1ee245b.svg";
export { ForwardRef as ReactComponent };